import styled from '@emotion/styled'

export const BankCardDisplayStyled = styled.strong({
  display: 'inline-flex',

  '& :not(:last-child)': {
    marginRight: '0.5ch',
  },
})
